<template>
  <default-template-message class="mb30">
      <div class="default-email-message-template">
      <div class="default-email-message-template__section">
         <email-message-template-text-area
          class="default-email-message-template__title"
          field-name="greeting"
          :value="templateData.greeting"
          :max-length="fieldsMaxLength.greeting"
          @field-input="onTreatmentCreatedFieldInput"
          @field-change="onTreatmentCreatedFieldChange"
        />

        <email-message-template-text-area
          class="default-email-message-template__paragraph"
          field-name="bodyPartOne"
          :value="fullMessage"
          :max-length="fieldsMaxLength.bodyPartOne"
          @field-input="onTreatmentCreatedFieldInput"
          @field-change="onTreatmentCreatedFieldChange"
        />
      </div>

      <slot name="treatment-details"></slot>

      <email-message-template-signature-section :template-data="templateData" />
    </div>
  </default-template-message>
</template>

<script>
import DefaultTemplateMessage from '@/modules/dashboard/components/message-templates/common/DefaultTemplateMessage';
import EmailMessageTemplateTextArea from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateTextArea';
import EmailMessageTemplateSignatureSection from '@/modules/dashboard/components/message-templates/common/EmailMessageTemplateSignatureSection';

export default {
  name: 'TreatmentCreatedEmailTemplate',
  components: {
    DefaultTemplateMessage,
    EmailMessageTemplateSignatureSection,
    EmailMessageTemplateTextArea
  },
  props: {
    templateData: {
      type: Object,
      required: true
    },
    fieldsMaxLength: {
      type: Object,
      required: true
    }
  },
  computed: {
    fullMessage() {
      const link = this.templateData.link || '';
      const linkToFile = this.templateData.pdfFileLinkText || '';
      const body = this.templateData.bodyPartOne || '';

      return `${body} \n ${linkToFile} \n ${link}`.trim();
    },
    methods: {
      onTreatmentCreatedFieldInput(eventValue) {
        this.$emit('field-input', eventValue);
      },
      onTreatmentCreatedFieldChange(eventValue) {
        this.$emit('field-change', eventValue);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../assets/scss/message-templates/email-message-templates';
</style>
